import React, {Component} from 'react';
import {connect} from 'react-redux';
import ProjectCard from '../../components/Cards/ProjectCard';
import {Helmet} from 'react-helmet';

import PageHeader from '../../components/Headers/PageHeader';

const headerContent = {
    tag: 'Check out our',
    title: 'Projects',
    description: 'A collection of projects that provide creative and elegant solutions to a diverse array of social issues and problems. Find more about the projects here.'
};

class ProjectPage extends Component {
    render() {
        return (
            <div className={'container'}>
                <Helmet>
                    <title>Projects • D18</title>
                </Helmet>
                <PageHeader color={'pink'} content={headerContent}/>
                <section>
                    <div className={'grid'}>
                        {this.props.projects.map((project, i) => {
                            return (
                                <div className={'col--4'} key={i}>
                                    <ProjectCard project={project}/>
                                </div>
                            )
                        })}
                    </div>
                </section>
            </div>
        )
    }
}

const MapStateToProps = (state) => ({
    projects: state.projects,
});

export default connect(MapStateToProps)(ProjectPage);